import { CategoryDocuments } from '../../components/shared/CategoryDocuments';
import { DocumentsPageWrapper, DocumentsPageContainer, DocumentsGrid, DocumentCategoryCard, RGMCategoryCard, CategoryHeader, CategoryImage, CategoryTitle, CategoryContent } from './DocumentsPage.styles';

const documentCategories = [
    {
        id: 'ibc-code',
        category: 'IBC',
        title: 'IBC Code',
        fullTitle: 'International Code for the Construction and Equipment of Ships Carrying Dangerous Chemicals in Bulk (IBC Code)',
        image: '/assets/images/ibc_code.JPG',
    },
    {
        id: 'uscg',
        category: 'USCG',
        title: 'USCG',
        fullTitle: 'United States Coast Guard',
        image: '/assets/images/uscg2.jpg',
    },
    {
        id: 'fosfa-niop-eu',
        category: 'FOSFA',
        title: 'FOSFA, NIOP, EU',
        fullTitle: 'FOSFA, NIOP, EU',
        image: '/assets/images/fosfa.jpg',
    },
    {
        id: 'cargo-related',
        category: 'CargoRelated',
        title: 'Cargo Related',
        fullTitle: 'Cargo Related',
        image: '/assets/images/marpol.jpg',
    },
    {
        id: 'cleaning-chemicals',
        category: 'CleaningChemicals',
        title: 'Cleaning Chemicals',
        fullTitle: 'Cleaning Chemicals',
        image: '/assets/images/cleaning_chemicals.png',
    },
    {
        id: 'training-materials',
        category: 'TrainingMaterials',
        title: 'Training Materials',
        fullTitle: 'Training Materials',
        image: '/assets/images/training_materials.png',
    },
];

const rgmSubCategories = [
    { category: 'RGM', title: undefined },
    { category: 'RGM01', title: 'RGM 01 Introduction' },
    { category: 'RGM02', title: 'RGM 02 Quality' },
    { category: 'RGM03', title: 'RGM 03 HSE' },
    { category: 'RGM04', title: 'RGM 04 Cargo and Voyage' },
    { category: 'RGM05', title: 'RGM 05 Vessel' },
    { category: 'RGM06', title: 'RGM 06 Contingency' },
    { category: 'RGM07', title: 'RGM 07 Ship Forms' },
];

const nsmmSubCategories = [
    { category: 'NSMM01', title: '01 Instructions from Operations' },
    { category: 'NSMM02', title: '02 Memos from Operations' },
    { category: 'NSMM03', title: '03 Lesson Learned Notes' },
];

const DocumentsPage = () => {
    return (
        <DocumentsPageWrapper>
            <DocumentsPageContainer>
                <DocumentsGrid>
                    {documentCategories.map((cat) => (
                        <DocumentCategoryCard key={cat.id}>
                            <CategoryHeader>
                                <CategoryImage style={{ backgroundImage: `url(${cat.image})` }} />
                                <CategoryTitle>{cat.fullTitle}</CategoryTitle>
                            </CategoryHeader>
                            <CategoryContent>
                                {cat.id === 'training-materials' && (
                                    <p>
                                        <a href="https://vimeo.com/showcase/11467214" target="_blank" rel="noopener noreferrer">
                                            Chemistry courses on Vimeo
                                        </a>
                                    </p>
                                )}
                                <CategoryDocuments category={cat.category} hideEmptyMessage={cat.id === 'training-materials'} />
                            </CategoryContent>
                        </DocumentCategoryCard>
                    ))}

                    {/* RGM - Requirements and Guidelines Manual (expanded with sub-categories) */}
                    <RGMCategoryCard key="rgm">
                        <CategoryHeader>
                            <CategoryImage style={{ backgroundImage: `url(/assets/images/odfjell.jpg)` }} />
                            <CategoryTitle>Requirements and Guidelines Manual</CategoryTitle>
                        </CategoryHeader>
                        <CategoryContent>
                            {rgmSubCategories.map((sub) => (
                                <div key={sub.category}>
                                    {sub.title && <h4>{sub.title}</h4>}
                                    <CategoryDocuments category={sub.category} />
                                </div>
                            ))}

                            <h3 style={{ marginTop: '1.5rem' }}>Notice to Ship Managers and Masters</h3>
                            {nsmmSubCategories.map((sub) => (
                                <div key={sub.category}>
                                    <h4>{sub.title}</h4>
                                    <CategoryDocuments category={sub.category} />
                                </div>
                            ))}
                        </CategoryContent>
                    </RGMCategoryCard>
                </DocumentsGrid>
            </DocumentsPageContainer>
        </DocumentsPageWrapper>
    );
};

export default DocumentsPage;
